import { useState } from "preact/hooks";

export function useConst<T>(init: () => T): T {
    // oxlint-disable-next-line react/hook-use-state
    const [value] = useState<T>(init);
    return value;
}
